import { serviceLoading } from 'common/loaderReducer';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from "react-router-dom";
import { RootState } from '../../../store/types';
import { cleanState, searchByIDAPI } from './state/actions';
import { ErrorMsg, ConnectContainer, ContainerTitle, Box, BoxTitle, ImageBottomCotainer, ContainerBottom, Field, InlineRight, Indication } from './styles';
import imageBottom from './bottomconnect.png';
import InputField from "../../../components/InputField";
import ActionBar from "../../../components/ActionBar";
import { SEARCHING_BY_ID_API_REQUEST, SEARCHING_BY_LABEL_API_REQUEST } from 'features/Dealers/ConnectByLabel/state/actionTypes';
import SearchingListingsBox from './SearchingListingBox';
import FindListingsBox from './FindListingsBox';
import ResultsListingsBox from './ResultsListingsBox';
import ModalUpsellUpgrade from 'features/Home/Modals/UpsellUpgrade'
import { role1,role2,role3 } from 'features/Home/constants'
import { DEFAULT_WEBSITE_PROVIDER } from 'features/Home/utils';

const ConnectOption = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [showUpsellUpgrade, setShowUpsellUpgrade] = React.useState(false);

    const rootProps = useSelector((rootState: RootState) => {
        const isSearchingByID = serviceLoading(rootState, [SEARCHING_BY_ID_API_REQUEST]);
        return {
            websiteProvider: rootState.dealers.dealer.websiteProvider,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            searchedById: rootState.dealers.connectByLabel.searchedById,
            searchedByName: rootState.dealers.connectByLabel.searchedByName,
            searchResults: rootState.dealers.connectByLabel.searchResults,
            connect: rootState.dealers.connectByLabel.connect,            
            user: rootState.security.user,
            isSearchingByID
        }
    }, shallowEqual);

    React.useEffect(() => {
        dispatch(cleanState());
        dispatch(searchByIDAPI(rootProps.dealerId));
    }, []);

    React.useEffect(() => {
        if (rootProps.connect != undefined && rootProps.connect?.connected) {
            dispatch(cleanState());
            
            history.push({
                pathname: "/dealer/primary",
                search: `?dealer=${rootProps.dealerId}`
            })
        }
    }, [rootProps.connect]);


    React.useEffect(() => {
        setShowUpsellUpgrade(false);        
        if(rootProps.user && rootProps.user.role == role2)
            setShowUpsellUpgrade(true);        
    }, [rootProps.user]);

    return (
        <>
        <ConnectContainer>
            <ContainerTitle>
                Welcome to Listings Manager!
            </ContainerTitle>
            {
                rootProps.isSearchingByID != undefined && rootProps.isSearchingByID && !rootProps.searchedById &&
                <SearchingListingsBox />
            }
            {
                rootProps.isSearchingByID != undefined && !rootProps.isSearchingByID && (rootProps.searchResults == undefined || rootProps.searchResults.locations == undefined || rootProps.searchResults.locations.length == 0) &&
                <FindListingsBox />
            }
            {
                rootProps.isSearchingByID != undefined && !rootProps.isSearchingByID && rootProps.searchResults != undefined && !rootProps.searchResults.locations != undefined && rootProps.searchResults.locations.length > 0 &&
                <ResultsListingsBox />
            }
            <ErrorMsg>
                {
                    rootProps.searchedByName != undefined && rootProps.searchedByName && rootProps.isSearchingByID != undefined && !rootProps.isSearchingByID != undefined && rootProps.searchResults != undefined && rootProps.searchResults.locations != undefined && rootProps.searchResults.locations.length == 0 && (rootProps.searchResults.errorSearch == undefined || rootProps.searchResults.errorSearch == '') && (rootProps.connect == undefined || rootProps.connect.error == '') &&
                    `Error: There are not results matching the name`
                }
                {
                    rootProps.searchedByName != undefined && rootProps.searchedByName && rootProps.isSearchingByID != undefined && !rootProps.isSearchingByID != undefined && rootProps.searchResults != undefined && rootProps.searchResults.errorSearch != undefined && rootProps.searchResults.errorSearch != '' &&
                    `Error: ${rootProps.searchResults.errorSearch}`
                }
                {
                    rootProps.connect != undefined && !rootProps.connect?.connected &&
                    `Error: ${rootProps.connect.error}`
                }
            </ErrorMsg>
            <ContainerBottom>
                <ImageBottomCotainer>
                    <img src={imageBottom}></img>
                </ImageBottomCotainer>
            </ContainerBottom>
        </ConnectContainer>
        
        <ModalUpsellUpgrade
            shouldShow={showUpsellUpgrade}
            dealerId={rootProps.dealerId}
            websiteProvider={rootProps.websiteProvider ?? DEFAULT_WEBSITE_PROVIDER}
        />
        </>
    )
}

export default ConnectOption